module["exports"] = [
  "(0###) #########",
  "(0####) #######",
  "+49-###-#######",
  "+49-####-########"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/phone_number/formats.js
// module id = 370
// module chunks = 0